module.exports = __webpack_public_path__ + "img/icon-challenge-completed.e852f2e3.png";